import { gameEntity } from '@swf/core/analytics';

import type { StreamData } from '../types/CasinoGame';

export default <S>(service: S, data?: { games: StreamData }) =>
  data?.games?.games.slice(0, 20).map(gameEntity);
